<template>
  <l-container>
    <l-container-title slot="toolbar" text="Validate" icon="clipboard-check" color="bg-pastel-orange" />
    <div v-show="true" class="w-full flex flex-col">
      <div class="flex mt-4 w-full">
        <div class="w-1/2">
          <l-select v-model="networkSelection" class="text-xs" :data="networks" placeholder="Please select a network" :multiple="false" >
            <l-option v-for="i in networks" :key="i.value" class="text-xs" :value="i.value" :label="i.label" />
          </l-select>
        </div>
        <div class="w-1/2 ml-2">
          <l-select v-model="timeserieSelection" class="text-xs w-4" :data="timeseries" placeholder="Please select a timeserie" :multiple="false" >
            <l-option v-for="i in timeseries" :key="i.value" class="text-xs" :value="i.value" :label="i.label" />
          </l-select>
        </div>        
      </div>
      <div class="flex mt-2">
        <div class="mr-4">
          <vue-ctk-date-time-picker v-model="dateRangeFrom" :no-value-to-custom-elem="true" input-size="sm" format="YYYY-MM-DD HH:mm" formatted="YYYY-MM-DD HH:mm" label="Select from time" button-now-translation="Now" color="#7fa99b" :no-clear-button="true" :no-header="true">
            <l-input v-model="dateRangeFrom" type="text" placeholder>
              <template slot="prefix">
                <font-awesome-icon icon="clock" class="text-base text-gray-500"/>
              </template>
            </l-input>
          </vue-ctk-date-time-picker>
        </div>
        <div class="mr-4">
          <vue-ctk-date-time-picker v-model="dateRangeTo" :no-value-to-custom-elem="true" input-size="sm" format="YYYY-MM-DD HH:mm" formatted="YYYY-MM-DD HH:mm" label="Select to time" button-now-translation="Now" color="#7fa99b" :no-clear-button="true" :no-header="true">
            <l-input v-model="dateRangeTo" type="text" placeholder>
              <template slot="prefix">
                <font-awesome-icon icon="clock" class="text-base text-gray-500"/>
              </template>
            </l-input>
          </vue-ctk-date-time-picker>
        </div>
        <l-button type="success" :disabled="networkSelection == null || timeserieSelection == null || loading" @click="onClick">
          View datasets
        </l-button>
      </div>
    </div>
  </l-container>
</template>
<script>
import { LSelect, LOption, LButton, LInput } from "@/components/forms";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import * as moment from "moment";

export default {
  name: "LLSelection",
  components: {
    LSelect,
    LOption,
    LButton,
    LInput,
    VueCtkDateTimePicker
  },
  props: ["networks", "loading"],
  data() {
    return {
      networkSelection: null,
      timeserieSelection: null,
      dateRangeFrom: moment()
        .add(-1, "weeks")
        .format("YYYY-MM-DD"),
      dateRangeTo: moment()
        .add(1, "days")
        .format("YYYY-MM-DD")
    };
  },
  computed: {
    timeseries() {
      const sel = this.networks.find(t => {
        return t.value == this.networkSelection;
      });
      this.timeserieSelection = null;
      if (!sel) return [];
      return sel.timeseries.map(y => {
        return { label: y[1] + ", " + y[2], value: y[0] };
      });
    }
  },
  methods: {
    onClick() {
      this.$emit("click", {
        id: this.timeserieSelection,
        from: this.dateRangeFrom,
        to: this.dateRangeTo
      });
    }
  }
};
</script>
